var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"loading":_vm.loadingGestion,"color":_vm.colores.primario,"dark":""},on:{"click":_vm.reporte1}},[_vm._v("EXCEL DE PQRS")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }